import { lazyLoadAction, lazyLoadFunction } from '../../../utils/lazyLoad';

export const updateSessionRegistration = lazyLoadFunction(
  () => import(/* webpackChunkName: "registration" */ './internal')
    .then(m => m.updateSessionRegistration));

export const updateAdmissionItemRegistration = lazyLoadFunction(
  () => import(/* webpackChunkName: "registration" */ './internal')
    .then(m => m.updateAdmissionItemRegistration));

export const calculatePricing = lazyLoadAction(
  () => import(/* webpackChunkName: "registration" */ './pricing')
    .then(m => m.calculatePricing));

export const getPricing = lazyLoadAction(
  () => import(/* webpackChunkName: "registration" */ './pricing')
    .then(m => m.getPricing));

export const updateRegCartWithGuests = lazyLoadFunction(
  () => import(/* webpackChunkName: "registration" */ './guests')
    .then(m => m.updateRegCartWithGuests));

export const updateGuestsInRegCart = lazyLoadAction(
  () => import(/* webpackChunkName: "registration" */ './guests')
    .then(m => m.updateGuestsInRegCart));

export const setCurrentGuestEventRegistration = lazyLoadAction(
  () => import(/* webpackChunkName: "registration" */ './guests')
    .then(m => m.setCurrentGuestEventRegistration));

export const removeGuestByEventRegistrationId = lazyLoadFunction(
  () => import(/* webpackChunkName: "registration" */ './guests')
    .then(m => m.removeGuestByEventRegistrationId));

export const updateGuestDetails = lazyLoadAction(
  () => import(/* webpackChunkName: "registration" */ './guests')
    .then(m => m.updateGuestDetails));

export const clearTemporaryGuestInformation = lazyLoadAction(
  () => import(/* webpackChunkName: "registration" */ './guests')
    .then(m => m.clearTemporaryGuestInformation));

export const removeEventRegistrationFromRegCart = lazyLoadAction(
  () => import(/* webpackChunkName: "registration" */ './group')
    .then(m => m.removeEventRegistrationFromRegCart));

export const removeGroupMembersFromRegCart = lazyLoadAction(
  () => import(/* webpackChunkName: "registration" */ './group')
    .then(m => m.removeGroupMembersFromRegCart));

export const addGroupMemberInRegCart = lazyLoadAction(
  () => import(/* webpackChunkName: "registration" */ './group')
    .then(m => m.addGroupMemberInRegCart));

export const navigateToGroupMemberRegistration = lazyLoadAction(
  () => import(/* webpackChunkName: "registration" */ './group')
    .then(m => m.navigateToGroupMemberRegistration));

export const startRegistration = lazyLoadAction(
  () => import(/* webpackChunkName: "registration" */ './workflow')
    .then(m => m.startRegistration));

export const startModification = lazyLoadAction(
  () => import(/* webpackChunkName: "registration" */ './workflow')
    .then(m => m.startModification));

export const finalizeRegistration = lazyLoadAction(
  () => import(/* webpackChunkName: "registration" */ './workflow')
    .then(m => m.finalizeRegistration));

export const waitForRegCartCheckoutCompletionUi = lazyLoadAction(
  () => import(/* webpackChunkName: "registration" */ './workflow')
    .then(m => m.waitForRegCartCheckoutCompletionUi));

export const startCancelRegistration = lazyLoadAction(
  () => import(/* webpackChunkName: "registration" */ './workflow')
    .then(m => m.startCancelRegistration));

export const finalizeCancelRegistration = lazyLoadAction(
  () => import(/* webpackChunkName: "registration" */ './workflow')
    .then(m => m.finalizeCancelRegistration));

export const startDeclineRegistration = lazyLoadAction(
  () => import(/* webpackChunkName: "registration" */ './workflow')
    .then(m => m.startDeclineRegistration));

export const startWaitlistRegistration = lazyLoadAction(
  () => import(/* webpackChunkName: "registration" */ './workflow')
    .then(m => m.startWaitlistRegistration));

export const finalizeWaitlistRegistration = lazyLoadAction(
  () => import(/* webpackChunkName: "registration" */ './workflow')
    .then(m => m.finalizeWaitlistRegistration));

export const finalizeDeclineRegistration = lazyLoadAction(
  () => import(/* webpackChunkName: "registration" */ './workflow')
    .then(m => m.finalizeDeclineRegistration));

export const saveRegistration = lazyLoadAction(
  () => import(/* webpackChunkName: "registration" */ './workflow')
    .then(m => m.saveRegistration));

export const updateRegCart = lazyLoadFunction(
  () => import(/* webpackChunkName: "registration" */ './workflow')
    .then(m => m.updateRegCart));

export const updateTravelFlagInRegCart = lazyLoadAction(
  () => import(/* webpackChunkName: "registration" */ './workflow')
    .then(m => m.updateTravelFlagInRegCart));

export const applyPartialEventRegistrationUpdate = lazyLoadAction(
  () => import(/* webpackChunkName: "registration" */ './partialUpdates')
    .then(m => m.applyPartialEventRegistrationUpdate));

export const setRegistrationTypeId = lazyLoadAction(
  () => import(/* webpackChunkName: "registration" */ './registrationTypes')
    .then(m => m.setRegistrationTypeId));

export const runRegistrationTypeChangeValidationsForPrimaryAndGuest = lazyLoadFunction(
  () => import(/* webpackChunkName: "registration" */ './registrationTypes')
    .then(m => m.runRegistrationTypeChangeValidationsForPrimaryAndGuest));

export const restoreRegistration = lazyLoadAction(
  () => import(/* webpackChunkName: "registration" */ './restore')
    .then(m => m.restoreRegistration));

export const restoreRegistrationFromOtherTab = lazyLoadAction(
  () => import(/* webpackChunkName: "registration" */ './restore')
    .then(m => m.restoreRegistrationFromOtherTab));
